import toast from "react-hot-toast";
import axios from "axios";
import { serverURL } from './auth';

const slugifyText = (text) => {

  return text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

};

const axiosGet = async (url, params={}) => {
  try {
    const res = await axios.get(`${serverURL}/api/${url}`, {params});

    if (res.status === 200) {
      return res.data.results;
    }
  } catch (err) {
    //console.error('Error occurred:', err.message);
    return [];
  }
};

const getCategories = async (tableName) => {
  const categories = await axiosGet(`categories/getcategories/${tableName}`);
  return categories;
};

const addNewCategory = async (category) => {
  try {
    const formData = new FormData();

    formData.append(`uploadCategory`, category.image.file);
    formData.append('categoryName', category.name);
    formData.append('table', category.table);

    const res = await axios.post(`${serverURL}/api/categories/addnewcategory`, formData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    if (res.status === 200) {
      toast.success("Sikeres kategória létrehozás!")
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      // Hibás hitelesítési adatok
      return { success: false, error: "Invalid credentials" };
    } else {
      // Egyéb hibák
      toast.error("Szerver hiba");
      return { success: false, error: "An error occurred" };
    }
  }
};

const deleteCategory = async (categoryId) => {
  try {
    const res = await axios.put(`${serverURL}/api/categories/deletecategory`, { categoryId }, { withCredentials: true });

    if (res.status === 200) {
      toast.success("Sikeres kategória törlés!");
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {

      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error("Szerver hiba!");
      return { success: false, error: "An error occurred" };
    }
  }
};

const addNewProduct = async (productData) => {

  try {
    const formData = new FormData();

    if (productData.guide) {
      formData.append(`uploadData`, productData.guide, productData.guide.name);
    } else {
      console.error('No PDF found in productData.');
    }


    if (productData.images && Array.isArray(productData.images)) {
      productData.images.forEach((image, index) => {
        if (image.file) {
          formData.append(`uploadData`, image.file, image.file.name);
        } else {
          console.error(`A ${index}. has no uri.`);
        }
      });
    } else {
      alert('Az images nem tömb.');
    }


    formData.append('tableName', productData.tableName);
    formData.append('name', productData.name);
    formData.append('price', JSON.stringify(productData.price));
    formData.append('category_id', productData.categoryId);
    formData.append('description', productData.description);
    formData.append('stock', JSON.stringify(productData.stock));
    formData.append('weight', JSON.stringify(productData.weight));
    formData.append('unitType', JSON.stringify(productData.unitType));
    formData.append('productOptions', JSON.stringify(productData.productOptions));

    const res = await axios.post(`${serverURL}/api/products/addnewproduct`, formData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    if (res.status === 200) {
      toast.success("Sikeres termék feltöltés!");
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error("Szerver hiba!");
      return { success: false, error: "An error occurred" };
    }
  }
};

const getPreparedMaterials = async () => {
  const preparedMaterials = await axiosGet('products/preparedmaterials');
  return preparedMaterials;
};

const getFinishedProducts = async () => {
  const finishedProducts = await axiosGet('products/finishedproducts');
  return finishedProducts;
};

const getMaterials = async () => {
  const materials = await axiosGet('products/materials');
  return materials;
};

const getRandomProducts = async () => {
  const randomProducts = await axiosGet('products/randomproducts');
  return randomProducts;
};

const getProduct = async (tableName, productId) => {
  try {
    const res = await axios.get(`${serverURL}/api/products/getproduct/${tableName}/${productId}`);

    if (res.status === 200) {
      return res.data.results[0];
    }
  } catch (err) {
    //console.error('Error occurred:', err.message);
    return [];
  }
};

const getProductsVariables = async (products) => {
  const productVariables = await axiosGet('products/getproductsvariables', {products});
  return productVariables;
};

const getHomeProducts = async () => {
  const homeProducts = await axiosGet('home/homeproducts');
  return homeProducts;
};

const deleteProduct = async (tableName, productId) => {
  try {
    const res = await axios.put(`${serverURL}/api/products/deleteproduct`, { tableName, productId }, { withCredentials: true });

    if (res.status === 200) {
      toast.success("Sikeres termék törlés!")
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {

      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error('Szerver hiba');
      return { success: false, error: "An error occurred" };
    }
  }
};

const highlightProduct = async (tableName, productId, isHighlighted) => {
  try {
    const res = await axios.put(`${serverURL}/api/products/highlightproduct/${tableName}/${productId}`, { isHighlighted }, { withCredentials: true });

    if (res.status === 200) {
      toast.success('Sikeres módosítás!');
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {

      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error('Szerver hiba');
      return { success: false, error: "An error occurred" };
    }
  }
};

const editProduct = async (productData, productDetails, tableName) => {

  try {
    const formData = new FormData();

    if (productData.guide instanceof File) {
      formData.append('uploadData', productData.guide, productData.guide.name);
      formData.append('guide', productData.guide.name);
    } else if (typeof productData.guide === 'string') {
      formData.append('guide', productData.guide);
    } else {
      console.error('Hibás guide típus!');
    }

    if (productData.uploadedImages.length > 0) {
      productData.uploadedImages.forEach((image, index) => {
        if (image.file) {
          formData.append(`uploadData`, image.file, image.file.name);
        } else {
          console.error(`A ${index}. has no uri.`);
        }
      });
    } else {
      console.log('Nincs új kép');
    }

    formData.append('name', productData.name);
    formData.append('category_id', productData.category_id); 
    formData.append('description', productData.description); 
    formData.append('productDetails', JSON.stringify(productDetails));
    formData.append('incomingImages', JSON.stringify(productData.images));
    
    const res = await axios.put(`${serverURL}/api/products/editproduct/${tableName}/${productData.product_id}`, formData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    if (res.status === 200) {
      toast.success("Sikeres termék módosítás!");
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error("Szerver hiba.")
      return { success: false, error: "An error occurred" };
    }
  }
};

const getDeliveries = async () => {
  const deliveries = await axiosGet('deliveries/getdeliveries');
  return deliveries;
};

const getDeliveriesWithWeight = async (weight) => {
  const deliveries = await axiosGet('deliveries/getdeliverieswithweight', {weight});
  return deliveries;
};

const addNewDelivery = async (deliveries) => {
  try {
    const res = await axios.post(`${serverURL}/api/deliveries/addnewdelivery`, { deliveries }, {withCredentials: true});

    if (res.status === 200) {
      toast.success("Sikeres szállítási opció létrehozás.")
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      // Hibás hitelesítési adatok
      return { success: false, error: "Invalid credentials" };
    } else {
      toast.error('Szerver hiba.');
      return { success: false, error: "An error occurred" };
    }
  }
};

const deleteDelivery = async (deliveryId) => {
  try {
    const res = await axios.put(`${serverURL}/api/deliveries/deletedelivery`, { deliveryId }, {withCredentials: true});

    if (res.status === 200) {
      toast.success("Sikeres szállítási opció törlés!");
      return { success: true };
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      // Hibás hitelesítési adatok
      return { success: false, error: "Invalid credentials" };
    } else {
      // Egyéb hibák
      toast.error("Szerver hiba.");
      return { success: false, error: "An error occurred" };
    }
  }
};

const getGuides = async () => {
  const guides = await axiosGet('products/getpreparedmaterialsforguide');
  return guides;
};

export {
  getCategories,
  addNewCategory,
  addNewProduct,
  getPreparedMaterials,
  getFinishedProducts,
  getProduct,
  getMaterials,
  getRandomProducts,
  deleteCategory,
  deleteProduct,
  getHomeProducts,
  highlightProduct,
  editProduct,
  getDeliveries,
  addNewDelivery,
  deleteDelivery,
  getDeliveriesWithWeight,
  getProductsVariables,
  getGuides,
  slugifyText
};